import "../styles/cards.scss";

export function ScheduleCard(props) {
    return (
        <div className={"scheduleCard" + (props.end ? "" : " line")}>
            <div className="ch">
                <div className="scheduleNum">{props.num}</div>
                <div className="title">{props.title}</div>
                <div className="text">{props.text}</div>
                {props.data.map((data) => {
                    return <div className="scheduleItem">&#9679; {data} </div>;
                })}
            </div>
            <div className="i">{props.img && <img src={props.img}></img>}</div>
        </div>
    );
}
